export var FileErrorType;
(function (FileErrorType) {
    FileErrorType[FileErrorType["NoError"] = 0] = "NoError";
    FileErrorType[FileErrorType["TypeError"] = 1] = "TypeError";
    FileErrorType[FileErrorType["SizeError"] = 2] = "SizeError";
    FileErrorType[FileErrorType["TotalSizeError"] = 3] = "TotalSizeError";
    FileErrorType[FileErrorType["CorruptedError"] = 4] = "CorruptedError";
    FileErrorType[FileErrorType["DuplicateError"] = 5] = "DuplicateError";
})(FileErrorType || (FileErrorType = {}));
